import state from '../../state';
var queue = [];
var timer = null;
export var batchReport = function (eventName, params) {
    queue.push([eventName, params]);
    if (timer)
        return;
    timer = window.setInterval(function () {
        var items = queue.splice(0, 5);
        if (items.length) {
            var tea = state.tea;
            if (!tea)
                return;
            tea === null || tea === void 0 ? void 0 : tea(items);
        }
        if (!queue.length) {
            window.clearInterval(timer);
            timer = null;
        }
    }, 5000);
};
